import React from "react";
import {transformImage} from "../../utils/StoryblokService";
import Link from "next/link";
import Image from "next/image";

export default function BlogPostCard(props: any) {
    const post = props.el;

    const dateString = post.content.date;
    // Get month name from Date String
    const date = new Date(dateString);
    const options = {month: 'long'};
    // @ts-ignore
    const monthName = new Intl.DateTimeFormat('en-US', options).format(date);

    return <div className={"w-full break-all break-words"}>
        <article key={post.uuid}
                 className="flex flex-col items-start justify-between relative">

            <div className="relative aspect-video w-full hover:opacity-60">
                <Link href={post.full_slug} className={"absolute inset-0 z-10 cursor-pointer"}>
                </Link>

                <Image
                    fill={true}
                    src={transformImage(post.content.image.filename, "768x512")}
                    alt={post.content.title}
                    className="cursor-pointer aspect-[16/9] w-full rounded-2xl bg-gray-100 object-cover sm:aspect-[2/1] lg:aspect-[3/2]"
                />

                <div
                    className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-gray-900/10"/>
            </div>

            <div className="max-w-xl">
                <div className="mt-8 text-xs">
                    {/*<time dateTime={post.content.date} className="text-gray-500">*/}
                    {/*    {monthName} {date.getFullYear()}*/}
                    {/*</time>*/}
                    {post.tag_list.length > 0 &&
                        <span
                            className={"flex gap-2 mt-3"}
                        >
                        {post?.tag_list?.map((el: any, i: any) => {
                            return <span key={i}
                                         className={'bg-white text-primary border text-xs uppercase p-2 rounded-lg lg:text-gray-500 shadow'}
                            >{el}</span>
                        })}
                    </span>}
                </div>
                <div className="group relative">
                    <h3 className="mt-3 text-lg font-semibold leading-6 text-gray-900 group-hover:text-gray-600">
                        <Link href={post.full_slug}>
                            <span className="absolute inset-0"/>
                            {post.name}
                        </Link>
                    </h3>
                    <p className="mt-5 line-clamp-3 text-sm leading-6 text-gray-600">{post.content.intro}</p>
                </div>
                {/*<div className="relative mt-8 flex items-center gap-x-4">*/}
                {/*    <img src={post.author.imageUrl} alt=""*/}
                {/*         className="h-10 w-10 rounded-full bg-gray-100"/>*/}
                {/*    <div className="text-sm leading-6">*/}
                {/*        <p className="font-semibold text-gray-900">*/}
                {/*            <a href={post.author.href}>*/}
                {/*                <span className="absolute inset-0"/>*/}
                {/*                {post.author.name}*/}
                {/*            </a>*/}
                {/*        </p>*/}
                {/*        <p className="text-gray-600">{post.author.role}</p>*/}
                {/*    </div>*/}
                {/*</div>*/}
            </div>
        </article>
    </div>
}